export default "__VITE_ASSET__CTLVCKiv__"